<template lang="pug">
.installation-guide.container
  .breadcrumb-password-view.py-3.row
    Breadcrumb(:path-list='pathlist')
  .alert.alert-dismissible.alert-success(
    role='alert',
    v-if='getSolicitation.cdSolicitacao'
  )
    .alert__icon
      Icon(name='shield')
    .alert__content
      .text Parabéns! Sua solicitação foi aprovada com sucesso! Verifique seu e-mail.
    button.btn-close(
      type='button',
      data-bs-dismiss='alert',
      aria-label='Fechar'
    )
      Icon.mt-2(name='xmark')
  .title-installation-guide.text-start.mt-4
    h2.fs-1 Guia de instalação do Certificado Digital Financeiro e SSL
  .title-info-installation-guide.text-start.mt-3
    h5 Escolha abaixo como deseja instalar seu Certificado
  .title-info-installation-guide.text-start.mt-1
    .text Caso não deseje instalar seu Certificado agora, você poderá voltar aqui em outro momento.
  .row.justify-content-betwen.mt-5
    .col-lg-6.col-12.card.card-info.ms-2
      .img-box
        img(src='@/assets/images/lock.svg', alt='Desenho de um Cadeado')
      .text-card
        .text Tem CSR próprio?
        .text Então esta opção é pra você!
      router-link(:to='{ name: "LoginSSl" }')
        button.btn.btn-primary.gap-2.mx-auto.btn-sm.px-2.pb-2.d-flex.align-items-center
          Icon(name='lock')
          span.pt-1 Tenho CSR próprio

    .col-lg-6.col-12.card.card-info.ms-2
      .img-box
        img(
          src='@/assets/images/download.svg',
          alt='Desenho de uma seta para Download do emissor'
        )
      .text-card
        .text Não tem CSR próprio?
        .text Faça o download do nosso emissor.
      button.btn.btn-primary.gap-2.mx-auto.btn-sm.px-2.pb-2.d-flex.align-items-center(
        @click='issuerButtonClick'
      )
        Icon(name='download')
        span.pt-1 Fazer download do emissor
  #Accordion1.accordion
    .accordion-item
      #AccordionQuestionCSR.accordion-header
        .accordion-button.collapsed(
          type='button',
          data-bs-toggle='collapse',
          data-bs-target='#AccordionAnswerCSR',
          aria-controls='AccordionAnswerCSR'
        ) O que é CSR?
      #AccordionAnswerCSR.accordion-collapse.collapse(
        aria-labelledby='AccordionQuestionCSR',
        data-bs-parent='#Accordion1'
      )
        .accordion-body
          p.m-0.text-start.fs-6 #[strong CSR], cuja sigla significa
            |#[strong Certificate Signing Request],
            | é um arquivo de texto, gerado no mesmo servidor em que você planeja
            | instalar o certificado, a CSR contém informações (por exemplo, nome
            | comum, empresa, país) que a Autoridade Certificadora (AC) usará para
            | criar seu certificado. Ela também contém a chave pública que será incluída
            | em seu certificado e é assinada com a chave privada correspondente.
  #Accordion2.accordion
    .accordion-item
      #AccordionFindCSR.accordion-header
        .accordion-button.collapsed(
          type='button',
          data-bs-toggle='collapse',
          data-bs-target='#AccordionWhereFindCSR',
          aria-controls='AccordionWhereFindCSR'
        ) Onde encontro o código CSR?
      #AccordionWhereFindCSR.accordion-collapse.collapse(
        aria-labelledby='AccordionFindCSR',
        data-bs-parent='#Accordion2'
      )
        .accordion-body
          p.m-0.text-start.fs-6 A geração da CSR dependerá da plataforma que você estiver
            |
            | usando. Através do link a seguir, damos instruções de como fazer para gerar a CSR.
            router-link.link(:to='{ name: "generateCSRResquest" }')
              span Instruções para gerar CSR
              Icon.mx-2.icon(name='up-right-from-square')
  #Accordion3.accordion
    .accordion-item
      #AccordionDontHaveCSR.accordion-header
        .accordion-button.collapsed(
          type='button',
          data-bs-toggle='collapse',
          data-bs-target='#AccordionWHatToDo',
          aria-controls='AccordionWHatToDo'
        ) Não tenho o código CSR neste momento, o que fazer?
      #AccordionWHatToDo.accordion-collapse.collapse(
        aria-labelledby='AccordionDontHaveCSR',
        data-bs-parent='#Accordion3'
      )
        .accordion-body
          p.m-0.text-start.fs-6 Caso você não tenha a CSR para emissão do seu
            |
            | Certificado Digital SSL, você poderá utilizar nosso emissor. Basta fazer o download e
            |
            | executá-lo em seu computador.
            = ' '
            a.link(@click='issuerLinkClick', type='button')
              span Fazer download do emissor
              Icon.mx-2.icon(name='download')
  a#dowload-link(v-show='false', :href='issuerUrl')
  Contact
  ModalAreYouShure
  button#modal-are-you-shure-button(
    v-show='false',
    data-bs-target='#modal-are-you-shure',
    data-bs-toggle='modal'
  )
  ModalDownloadInstruction
  ModalOnlyUseOnDesktop
    template(v-slot:message)
      h3 A instalação de um Certificado Digital através do emissor,
        |
        | deve ser feita em um #[strong computador ou notebook.]
  button#modal-only-desktop-issuer-button(
    v-show='false',
    data-bs-target='#modal-only-desktop',
    data-bs-toggle='modal'
  )
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Icon from '@/components/Atoms/Icon.vue'
  import Input from '@/components/Atoms/Input.vue'
  import Breadcrumb from '@/components/Molecules/Breadcrumbs.vue'
  import Contact from '@/components/Molecules/Contact.vue'
  import { mapState } from 'pinia'
  import { useSolicitation } from '@/store/Pinia/useSolicitation.store'
  import { useAR, ArDataType } from '@/store/Pinia/useAR.store'
  import ModalOnlyUseOnDesktop from '@/components/templates/ModalOnlyUseOnDesktop.vue'
  import browserDeviceCheck from '@/utils/browserDeviceCheck'
  import ModalAreYouShure from './modals/ModalAreYouShure.vue'
  import ModalDownloadInstruction from './modals/ModalDownloadInstruction.vue'

  export default defineComponent({
    name: 'HomeView',
    components: {
      Contact,
      ModalAreYouShure,
      ModalDownloadInstruction,
      ModalOnlyUseOnDesktop,
      Icon,
      Input,
      Breadcrumb,
    },
    data: () => ({
      form: {
        arData: {} as ArDataType,
      },
      isMobile: browserDeviceCheck(),
    }),
    computed: {
      ...mapState(useSolicitation, ['getSolicitation']),
      ...mapState(useAR, ['arData', 'getLinkEmissor']),
      issuerUrl() {
        return this.getLinkEmissor
      },
      pathlist() {
        return { 'Guia de instalação SSL': '#' }
      },
    },
    mounted() {
      this.form.arData = this.arData
    },
    methods: {
      issuerButtonClick() {
        if (this.isMobile) {
          return (
            document.getElementById(
              'modal-only-desktop-issuer-button',
            ) as HTMLButtonElement
          ).click()
        }

        return (
          document.getElementById(
            'modal-are-you-shure-button',
          ) as HTMLButtonElement
        ).click()
      },
      issuerLinkClick() {
        if (this.isMobile) {
          return (
            document.getElementById(
              'modal-only-desktop-issuer-button',
            ) as HTMLButtonElement
          ).click()
        }

        return (
          document.getElementById('dowload-link') as HTMLAnchorElement
        ).click()
      },
    },
  })
</script>

<style lang="stylus" scoped>
  .container
    margin-bottom: 8rem
    .alert .btn-close
      top: 0.2em
    .card
      width: 49%
      &:hover
        box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important
    .card-info
      img
        padding-top: 2rem
        height: 155px
      button
        margin-bottom: 2rem
      .text-card
        padding-top: 0.625rem
        padding-bottom: 0.625rem
    .accordion-item
      margin-top: 1rem

  .link
    color: #0080A3

  @media screen and (max-width: 990px)
    .card
      width: 96% !important
      margin-right: 0.5rem !important
      &:last-child
        margin-top: 1rem
</style>
